import { MDBIcon } from "mdb-react-ui-kit";
import React from "react";

import style from "./style.module.scss";

function ProfilePicture({
	url,
	isHome,
	isPost,
	isComment,
	isExplore,
	onClick,
}) {
	const getClass = () => {
		if (isPost) {
			return style.post;
		}
		if (isComment) {
			return style.comment;
		}
		if (isExplore) {
			return style.explore;
		}
		return style.default;
	};

	return (
		<div className={getClass()} onClick={onClick}>
			<div
				className={isHome ? style.profilePic : style.profilePicNotHome}
				style={{ cursor: isPost || isComment || isExplore ? "pointer" : "" }}
			>
				<img className={style.profilepic__image} src={url} alt='ProfilePic' />
				{!isPost && !isComment ? (
					<div className={style.profilepic__content}>
						<span className={style.profilepic__icon}>
							<MDBIcon fas icon='camera' />
						</span>
						<span className={style.profilepic__text}>Edit Profile</span>
					</div>
				) : (
					""
				)}
			</div>
		</div>
	);
}

export default ProfilePicture;
